export const adsTypes = {
  free: 'free',
  paid: 'paid',
  all: 'all'
}
